<template>
    <svg viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M12 3v11.687l-.003-.002c-1.822 1.495-3.547 3.508-4.842 6.182l-1.518-.734-1.52-.735c1.349-2.786 3.093-4.971 4.972-6.668-2.42-1.307-4.704-1.84-6.081-1.925l.209-3.368c1.687.104 4.262.688 6.988 2.069V3H12Z" />
    </svg>
</template>
